module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "grey lighten-4 elevation-0"
  }, [(!_vm.fatalError) ? _c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(!_vm.submited) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    class: _vm.isMobile ? 'my-3' : '',
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-subheader', [_vm._v("Identificação do aluno")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Curso",
      "prepend-icon": "class",
      "disabled": "",
      "items": _vm.courses,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.exam.course),
      callback: function($$v) {
        _vm.$set(_vm.exam, "course", $$v)
      },
      expression: "exam.course"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Aluno",
      "readonly": "",
      "prepend-icon": "subject"
    },
    model: {
      value: (_vm.exam.studentName),
      callback: function($$v) {
        _vm.$set(_vm.exam, "studentName", $$v)
      },
      expression: "exam.studentName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    class: _vm.isMobile ? 'my-3' : '',
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-subheader', [_vm._v("Informações do trabalho")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo",
      "prepend-icon": "create",
      "disabled": "",
      "items": _vm.types,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.exam.type),
      callback: function($$v) {
        _vm.$set(_vm.exam, "type", $$v)
      },
      expression: "exam.type"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Título",
      "readonly": "",
      "prepend-icon": "title"
    },
    model: {
      value: (_vm.exam.title),
      callback: function($$v) {
        _vm.$set(_vm.exam, "title", $$v)
      },
      expression: "exam.title"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.evaluator) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    class: _vm.isMobile ? 'my-3' : '',
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-subheader', [_vm._v("Informações do avaliador")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Avaliador",
      "readonly": "",
      "prepend-icon": "person"
    },
    model: {
      value: (_vm.evaluatorName),
      callback: function($$v) {
        _vm.evaluatorName = $$v
      },
      expression: "evaluatorName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Início",
      "readonly": "",
      "prepend-icon": "lock_open"
    },
    model: {
      value: (_vm.evaluation.startDate),
      callback: function($$v) {
        _vm.$set(_vm.evaluation, "startDate", $$v)
      },
      expression: "evaluation.startDate"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Término",
      "readonly": "",
      "prepend-icon": "lock_outline"
    },
    model: {
      value: (_vm.evaluation.finishDate),
      callback: function($$v) {
        _vm.$set(_vm.evaluation, "finishDate", $$v)
      },
      expression: "evaluation.finishDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (!_vm.evaluation.started && _vm.canEdit) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "success"
    },
    on: {
      "click": _vm.startEvaluation
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("start")]), _vm._v(" Iniciar avaliação\n            ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "info",
      "to": {
        path: '/bancas/avaliar'
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("undo")]), _vm._v(" Voltar\n            ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.evaluation.started) ? [_c('v-layout', {
    class: _vm.isMobile ? 'my-3' : '',
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-subheader', {
    staticClass: "title"
  }, [_vm._v("Ficha de avaliação")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  })], 1), _vm._v(" "), [(_vm.canViewOrEditCriteria) ? _c('div', _vm._l((_vm.orderedCriteria), function(criterion, idx) {
    return _c('v-layout', {
      key: criterion.id || idx,
      class: _vm.isMobile ? 'my-3' : 'mb-2',
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      class: _vm.isMobile ? 'mb-1' : '',
      attrs: {
        "xs12": "",
        "md8": ""
      }
    }, [_c('span', {
      class: ['ml-' + (criterion.pos_ext.split('.').length)]
    }, [_c('strong', {
      staticClass: "pr-2"
    }, [_vm._v(_vm._s(criterion.pos) + ".")]), _vm._v("\n                    " + _vm._s(criterion.description) + "\n                  ")])]), _vm._v(" "), (criterion.weight > 0) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "md2": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Peso",
        "readonly": "",
        "disabled": ""
      },
      model: {
        value: (criterion.weight),
        callback: function($$v) {
          _vm.$set(criterion, "weight", $$v)
        },
        expression: "criterion.weight"
      }
    })], 1) : _vm._e(), _vm._v(" "), (criterion.leaf) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "md2": ""
      }
    }, [_c('v-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "type": "number",
        "min": "0",
        "max": "10",
        "step": "0.01",
        "label": "Nota",
        "required": "",
        "readonly": _vm.evaluation.finished || !_vm.canEdit,
        "tabindex": idx + 1,
        "append-icon": criterion.status === 'sent' ? 'cloud_done' : '',
        "loading": criterion.status === 'sending'
      },
      on: {
        "change": function($event) {
          return _vm.submitCriterion(criterion, false)
        }
      },
      model: {
        value: (_vm.evaluation.criteriaScores[criterion.id]),
        callback: function($$v) {
          _vm.$set(_vm.evaluation.criteriaScores, criterion.id, $$v)
        },
        expression: "evaluation.criteriaScores[criterion.id]"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (idx < (_vm.orderedCriteria.length - 1) && _vm.orderedCriteria[idx + 1].pos_ext.split('.').length == 1),
        expression: "idx < (orderedCriteria.length - 1) && orderedCriteria[idx + 1].pos_ext.split('.').length == 1"
      }],
      staticClass: "mb-3"
    })], 1)
  }), 1) : _vm._e()], _vm._v(" "), _c('v-divider', {
    staticClass: "mb-3"
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "mb-2",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-subheader', [_c('span', {
    staticClass: "ml-1"
  }, [_c('strong', {
    staticClass: "pr-2"
  }, [_vm._v("Nota final")])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nota final",
      "loading": _vm.loadingFinalScore,
      "readonly": ""
    },
    model: {
      value: (_vm.formattedFinalScore),
      callback: function($$v) {
        _vm.formattedFinalScore = $$v
      },
      expression: "formattedFinalScore"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comentários",
      "prepend-icon": "rate_review",
      "multi-line": "",
      "auto-grow": "",
      "rows": "3",
      "readonly": _vm.evaluation.finished || !_vm.canEdit,
      "tabindex": 150,
      "append-icon": _vm.notesStatus == 'sent' ? 'cloud_done' : '',
      "loading": _vm.notesStatus == 'sending'
    },
    on: {
      "change": function($event) {
        return _vm.submitNotes(true)
      }
    },
    model: {
      value: (_vm.evaluation.notes),
      callback: function($$v) {
        _vm.$set(_vm.evaluation, "notes", $$v)
      },
      expression: "evaluation.notes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "color": "warning",
      "value": _vm.vErrors.any()
    }
  }, [_vm._v("\n                Preencha todos os campos do formulário para submeter sua avaliação, ou clique em "), _c('strong', [_vm._v("Continuar\n                  depois")]), _vm._v("\n                para continuar a avaliação em outro momento.\n              ")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "color": "error",
      "value": _vm.submitErrors.length > 0
    }
  }, [_vm._v("\n                Ocorreram os seguintes erros na submissão do formulário:\n                "), _c('ul', _vm._l((_vm.submitErrors), function(error) {
    return _c('li', {
      key: error
    }, [_vm._v(_vm._s(error))])
  }), 0)]), _vm._v(" "), (!_vm.evaluation.finished && _vm.canEdit) ? [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "info"
    },
    on: {
      "click": _vm.saveEvaluationData
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("save")]), _vm._v(" Continuar depois\n                ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "type": "submit",
      "disabled": _vm.vErrors.any(),
      "light": "",
      "color": "success"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("done")]), _vm._v(" Finalizar\n                ")], 1)] : _vm._e(), _vm._v(" "), _c('v-alert', {
    attrs: {
      "color": "info",
      "value": !_vm.evaluation.finished && !_vm.canEdit
    }
  }, [_vm._v("\n                A avaliação ainda não foi finalizada.\n              ")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "color": "success",
      "value": _vm.evaluation.finished
    }
  }, [_vm._v("\n                A avaliação já foi finalizada.\n              ")])], 2)], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.submited) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "green darken-1"
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v("Registro de avaliação enviado")])]), _vm._v(" "), _c('v-card-text', {
    attrs: {
      "height": "75px"
    }
  }, [_c('v-icon', {
    staticClass: "mr-4",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("done")]), _vm._v("\n              A sua avaliação do trabalho foi "), _c('strong', [_vm._v(_vm._s(_vm.finishOk ? 'registrada e finalizada' : 'registrada'))]), _vm._v(" com\n              sucesso no sistema para a banca\n              "), _c('v-chip', {
    staticClass: "green darken-1 white--text"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'examEvaluate',
        params: {
          id: _vm.exam.id
        }
      }
    }
  }, [_vm._v("n.º " + _vm._s(_vm.exam.id))])], 1), _vm._v(".\n            ")], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "success",
      "to": {
        name: 'exams',
        params: {
          page: 1
        }
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("list")]), _vm._v(" Voltar para a lista\n              ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "info",
      "to": {
        name: 'bancas',
        params: {
          page: 1
        }
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("undo")]), _vm._v(" Voltar para as bancas\n              ")], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1) : _c('v-card-text', [_c('v-alert', {
    staticClass: "mt-5",
    attrs: {
      "type": "error",
      "value": _vm.fatalError,
      "outlined": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.fatalError) + "\n    ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("undo")]), _vm._v(" Voltar\n    ")], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de2fad88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExamEvaluateDetail.vue
// module id = 260
// module chunks = 0